import classNames from "components/ui/classNames";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import React from "react";

export type RefObjectForHighchartsReact = {
  chart: Highcharts.Chart;
  container: React.RefObject<HTMLDivElement>;
};

interface HighchartsChartProps {
  options: Highcharts.Options;
  constructorType?: string;
  className?: string;
  immutable?: boolean;
  allowChartUpdate?: boolean;
  forwardedRef?: React.ForwardedRef<RefObjectForHighchartsReact | null>;
}
const HighchartsChart = React.forwardRef<RefObjectForHighchartsReact | null, HighchartsChartProps>(
  (
    { options, constructorType = "stockChart", className, immutable = false, allowChartUpdate = true, forwardedRef },
    chartRef,
  ) => {
    return (
      <div className={classNames("min-w-full touch-none rounded-xl", className)}>
        <HighchartsReact
          ref={forwardedRef || chartRef}
          highcharts={Highcharts}
          constructorType={constructorType}
          immutable={immutable}
          allowChartUpdate={allowChartUpdate}
          options={{
            ...options,
            accessibility: {
              enabled: false,
            },
          }}
          containerProps={{
            style: {
              width: "100%",
              height: "100%",
            },
          }}
        />
      </div>
    );
  },
);

export default HighchartsChart;
